document.addEventListener('DOMContentLoaded', function() {
  const productBundledTabs = document.querySelectorAll('.bundled-products-tabs');
  productBundledTabs.forEach(productBundledTab => {
    const productButtons = productBundledTab.querySelectorAll('.bundled-products-tabs__product');
    const shopifyBlocks = productBundledTab.querySelectorAll('.bundled-products-tabs__content .shopify-block');

    productButtons.forEach(button => {
      button.addEventListener('click', function() {
        const productId = this.getAttribute('data-product-id');

        console.log('productId: ', productId);

        // Remove active class from all buttons
        productButtons.forEach(productButton => productButton.classList.remove('bundled-products-tabs__product--active'));

        // Add active class to the clicked button
        this.classList.add('bundled-products-tabs__product--active');

        // Toggle rich-text active class
        shopifyBlocks.forEach(shopifyBlock => {
          if (shopifyBlock.querySelector('[data-product-id]').getAttribute('data-product-id') === productId) {
            console.log('add active class');
            shopifyBlock.classList.add('shopify-block--active');
          } else {
            shopifyBlock.classList.remove('shopify-block--active');
          }
        });
      });
    });
  });
});
